export default function initData() {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_MODULE_DATA',
		});
	};
}